module.exports = __webpack_public_path__ + "img/T1B_xs_05.7505a68a.png";